import React from 'react';

import { View } from './View/View';
import { List } from './List';

export const applicationsFormRoutes = {
  path: '/applicationsForm',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id',
      element: <View />,
    },
  ],
};
